module.exports = __webpack_public_path__ + "img/buscando-duck.cde8aa64.gif";